"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markSeenDraftSunset = exports.markSeenReadOnlyAlert = exports.markSeenOnboarding = exports.fetchUserSettings = void 0;

var _ActionTypes = _interopRequireDefault(require("ComposeUI/redux/ActionTypes"));

var _utils = require("ComposeUI/lib/utils");

var _SettingsManager = _interopRequireDefault(require("ComposeUI/data/SettingsManager"));

var settingsManager = new _SettingsManager.default();
var fetchUserSettingsPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_SETTINGS_PENDING);
var fetchUserSettingsSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_SETTINGS_SUCCEEDED);
var fetchUserSettingsFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_SETTINGS_FAILED);
var showOnboarding = (0, _utils.createAction)(_ActionTypes.default.SHOW_ONBOARDING_MODAL);

var fetchUserSettings = function fetchUserSettings(id) {
  return function (dispatch) {
    dispatch(fetchUserSettingsPending());
    settingsManager.fetch(id).then(function (resp) {
      return dispatch(fetchUserSettingsSucceeded(resp));
    }, function (resp) {
      if (resp.status === 404) {
        // a 404 usually means the user doesn't have user settings in this scope
        // yet, so just show the onboarding and save a default value. when the
        // user loads the onboarding this will get overridden.
        dispatch(showOnboarding());
        settingsManager.save(id, {
          seenOnboarding: false,
          seenReadOnlyAlert: false
        });
      } else {
        dispatch(fetchUserSettingsFailed(resp));
      }
    });
  };
};

exports.fetchUserSettings = fetchUserSettings;

var markSeenOnboarding = function markSeenOnboarding(id, currentSettings) {
  settingsManager.save(id, Object.assign({}, currentSettings, {
    seenOnboarding: true
  }));
};

exports.markSeenOnboarding = markSeenOnboarding;

var markSeenReadOnlyAlert = function markSeenReadOnlyAlert(id, currentSettings) {
  settingsManager.save(id, Object.assign({}, currentSettings, {
    seenReadOnlyAlert: true
  }));
};

exports.markSeenReadOnlyAlert = markSeenReadOnlyAlert;

var markSeenDraftSunset = function markSeenDraftSunset(id, currentSettings, timeSeen) {
  settingsManager.save(id, Object.assign({}, currentSettings, {
    seenDraftSunset: timeSeen
  }));
};

exports.markSeenDraftSunset = markSeenDraftSunset;